import { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { DataGrid, GridToolbar, useGridApiRef } from '@mui/x-data-grid';		//https://mui.com/x/react-data-grid/ [MIT version]
import { Box, Alert, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

import Api from '../../Services/Api';
import {PAGE_SIZE, pageSizeOptions} from '../../Config/constants.js';
import { useTheme } from '@emotion/react';
import ActionButton from '../ActionButton.js';
import VisibilityIcon from '@mui/icons-material/Visibility';

function CustomerSmsOverview(props) {
    const { customerId, lastUpdate } = props;
    const apiRef = useGridApiRef();	//https://mui.com/x/api/data-grid/
    const [rows, setRows] = useState([]);
    const [displayAlert, setDisplayAlert] = useState(0);
	const [displayDialog, setDisplayDialog] = useState(false);
	const [displayDialogContent, setDisplayDialogContent] = useState("");

    const columns = [
        {
            field: 'message',
            headerName: 'Messaggio',
            flex: 2,
        },
        {
            field: 'recipient',
            headerName: 'Telefono',
            flex: 1,
        },
        {
            field: 'sent_at',
            headerName: 'Data invio',
            flex: 1,
            type: 'dateTime',
            valueGetter: (params) => params.row.sent_at ? new Date(params.row.sent_at) : null,
            valueFormatter: (params) => params.value ? params.value.toLocaleDateString('it-IT') + ' ' + params.value.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '',
        },
        {
			field: 'id',
			headerName: 'Azioni',
			flex: 1,
			renderCell: (params) => {
				function onShow(e) {
					e.stopPropagation(); // don't select this row after clicking
                    setDisplayDialogContent(params.row.message);
                    setDisplayDialog(true);
				};
				return <>
					<ActionButton title={"Visualizza Messaggio Esteso"} onClick={onShow}>
						<VisibilityIcon />
					</ActionButton>
				</>
			}
		}
    ];

    const handleClose = () => {
		setDisplayDialogContent("");
		setDisplayDialog(false);
	};

    useEffect(() => {
        let endPoint = `message/${customerId}/list`;
                
        try {
            Api.get({endpoint: endPoint, contentType : 'application/json'})
            .then(response => {
                setRows(response.data.list);
            })
            .catch(error => {
                console.log(JSON.stringify(error));
                setDisplayAlert(-1);
            });
        } catch (error) {
            console.log(JSON.stringify(error));
            setDisplayAlert(-1);
        }
    }, [lastUpdate]);	// eslint-disable-line react-hooks/exhaustive-deps

    const theme = useTheme();
    return (
        <>
            <h5>Lista SMS inviati</h5>
            <Box sx={{ width: '100%', minWidth: '800px' }}>
                <ThemeProvider theme={theme}>
                    <DataGrid
                        //onRowDoubleClick={hook}
                        sx={{ minHeight: '300px' }}
                        rows={rows}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: PAGE_SIZE,
                                },
                            },
                        }}
                        apiRef={apiRef}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            columnsPanel: {
                                disableHideAllButton: true,
                            },
                            toolbar: { 
                                showQuickFilter: true 
                            }
                        }}
                        pageSizeOptions={pageSizeOptions}
                    />
                </ThemeProvider>
                {displayAlert === -1 && (
                    <Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
                )}
            </Box>
            <Dialog
                open={displayDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Messaggio Esteso
                </DialogTitle>
                <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {displayDialogContent}
                        </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Chiudi</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default CustomerSmsOverview;